import React from 'react';
import StatisticsCard from '../common/StatisticsCard';
import { useFetch } from '../../hooks/useCallApi';

const ComplaintsStatistics = () => {
  const { data, isLoading, isError } = useFetch(
    ['complaints-statistics'],
    (api) => api.admin.complaints.getStatistics()
  );

  const statistics = data?.data || {};

  const stats = [
    {
      label: "Total Complaints",
      value: statistics.total_complaints || 0,
      bgColor: "bg-blue-100",
      textColor: "text-blue-600",
      description: "All recorded complaints"
    },
    {
      label: "Active Cases",
      value: statistics.total_active_complaints || 0,
      bgColor: "bg-teal-100",
      textColor: "text-teal-600",
      description: "Currently in progress"
    },
    {
      label: "Resolved",
      value: statistics.total_resolved_complaints || 0,
      bgColor: "bg-green-100",
      textColor: "text-green-600",
      description: "Successfully closed"
    },
    {
      label: "Pending",
      value: statistics.total_pending_complaints || 0,
      bgColor: "bg-orange-100",
      textColor: "text-orange-600",
      description: "Awaiting action"
    },
    {
      label: "Dismissed",
      value: statistics.total_dismissed_complaints || 0,
      bgColor: "bg-red-100",
      textColor: "text-red-600",
      description: "Closed without action"
    }
  ];

  if (isLoading) {
    return <div className="p-4 text-sm text-gray-500">Loading statistics...</div>;
  }

  if (isError) {
    return <div className="p-4 text-sm text-red-500">Failed to load complaint statistics.</div>;
  }

    return <StatisticsCard 
    stats={stats} 
    columns="xl:grid-cols-5" 
    text="text-xs"
  />;
};

export default ComplaintsStatistics;